
import request from '@/utils/request'
import { ENABLE_API_DBG } from "@/appConfig.js";

function channels () {
  return request({
    url: `/my/channels`,
    method: 'get',
  })
}

function recshares () {
  return request({
    url: `/my/recshares`,
    method: 'get',
  })
}

function depts () {
  return request({
    url: `/my/depts`,
    method: 'get',
  })
}

function changePasswd(params) {
  const url = `/my/password`;
  ENABLE_API_DBG &&
    console.log(
      `api.my.changePasswd: url = ${url}, params = ${JSON.stringify(params)}`
    );
  return request({
    url,
    method: "patch",
    data: params,
  });
}

export default {
  depts,
  recshares,
  channels,
  changePasswd,
}
